import { ASSETS } from "@/lib/constants";

const NURSE_HERO = ASSETS.nurseHero;

export default function Trust() {
  return (
    <section
      data-testid="trust-section"
      className="relative bg-black border-t border-white/5"
    >
      <div className="grid lg:grid-cols-12">
        {/* Image side */}
        <div className="lg:col-span-6 relative min-h-[420px] lg:min-h-[760px] bg-black">
          <img
            src={NURSE_HERO}
            alt="ER nurse checking a reference on her phone during a night shift"
            className="absolute inset-0 w-full h-full object-cover object-[center_25%]"
            data-testid="trust-image"
          />
          {/* Feather the photo into the black page: a base tint + radial
              vignette melt the dim room surroundings into black so only the
              lit subject reads, then edge fades remove any hard rectangle. */}
          <div className="absolute inset-0 bg-black/35" />
          <div
            className="absolute inset-0"
            style={{
              background:
                "radial-gradient(ellipse 42% 48% at 50% 42%, transparent 12%, rgba(0,0,0,0.6) 45%, rgba(0,0,0,0.98) 72%)",
            }}
          />
          <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-black to-transparent" />
          <div className="absolute inset-x-0 bottom-0 h-44 bg-gradient-to-t from-black to-transparent" />
          <div className="absolute inset-y-0 left-0 w-56 bg-gradient-to-r from-black via-black/70 to-transparent" />
          <div className="absolute inset-y-0 right-0 w-64 bg-gradient-to-l from-black via-black/70 to-transparent" />
          <div className="absolute top-8 left-8 font-mono text-[10px] uppercase tracking-[0.3em] text-white/70 bg-black/40 border border-white/10 px-3 py-2">
            //  shift · 19:42 · bed 7
          </div>
        </div>

        {/* Content side */}
        <div className="lg:col-span-6 px-5 md:px-10 lg:px-16 py-24 lg:py-36 flex flex-col justify-center">
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#FF2A2A] mb-4">
            § 04 · trust
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[0.95] max-w-xl">
            Built <span className="italic font-light">by nurses,</span>
            <br />
            for nurses.
          </h2>
          <p className="mt-8 text-base text-white/60 max-w-lg leading-relaxed">
            Stable-ish is shaped on the floor — every prompt, every workflow,
            every shortcut comes from working ER and ICU clinicians. We test
            against real shift questions, not Q-bank trivia.
          </p>
        </div>
      </div>
    </section>
  );
}
